import axios from "axios";
import type { GetKeyFOBDetailsAPIResponse, GetQueueListAPIResponse, GetScheduleListAPIResponse, GetVehicleListAPIResponse as GetVehicleListAPIResponse, LogParkingHistoryApiResponse, ParamsObject } from "../shared/interface/parking.interface";

export const getScheduleListByRequestId = async (params: ParamsObject) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/parking/schedule-list/${params.requestId}?page=${params.page}&pageSize=${params.pageSize}`;

    if (params.customerId) {
      query += `&customerId=${params.customerId}`;
    }

    if (params.locationId) {
      query += `&locationId=${params.locationId}`;
    }

    if (params.clientId) {
      query += `&clientId=${params.clientId}`;
    }

    if (params.searchQuery) {
      query += `&searchQuery=${params.searchQuery}`;
    }

    const res = await axios.get(query);

    return res.data as GetScheduleListAPIResponse;
  } catch (error) {
    throw error;
  }
};

export const getQueueList = async (params: ParamsObject) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/parking/queue-list?page=${params.page}&pageSize=${params.pageSize}`;

    if (params.customerId) {
      query += `&customerId=${params.customerId}`;
    }

    if (params.locationId) {
      query += `&locationId=${params.locationId}`;
    }

    if (params.clientId) {
      query += `&clientId=${params.clientId}`;
    }

    if (params.searchQuery) {
      query += `&searchQuery=${params.searchQuery}`;
    }

    const res = await axios.get(query);

    return res.data as GetQueueListAPIResponse;
  } catch (error) {
    throw error;
  }
};

export const CancelScheduledList = async (id: number) => {
  let query = `${process.env.REACT_APP_API_URL}/parking/cancel-schedule-request/${id}`;

  try {
    const response = await axios.delete(query);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const CancelQueueList = async (id: number) => {
  let query = `${process.env.REACT_APP_API_URL}/parking/cancel-queue-request/${id}`;

  try {
    const response = await axios.delete(query);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const validateKeyFob = async (key_fob_token: string, customerId: number, locationId: number) => {
  let query = `${process.env.REACT_APP_API_URL}/parking/validate-key-fob-and-retrieve-users/${key_fob_token}?customerId=${customerId}&locationId=${locationId}`;

  try {
    const response = await axios.get(query);
    return response.data as GetKeyFOBDetailsAPIResponse;
  } catch (error) {
    throw error;
  }
};

export const addQueueRequestAPI = async (formData: object) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/parking/add-queue-request`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVehicleTypeSlotCountList = async (customerId: number | null, locationId: number | null) => {
  let query = `${process.env.REACT_APP_API_URL}/dashboard/vehicle-list/${customerId}/${locationId}`;

  try {
    const response = await axios.get(query);
    return response.data as GetVehicleListAPIResponse;
  } catch (error) {
    throw error;
  }
};

export const getLogParkingListByRequestId = async (params: ParamsObject) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/parking/log-parking-list/${params.requestId}?`;

    if (params.page) {
      query += `&page=${params.page}`;
    }

    if (params.pageSize) {
      query += `&pageSize=${params.pageSize}`;
    }

    if (params.customerId) {
      query += `&customerId=${params.customerId}`;
    }

    if (params.locationId) {
      query += `&locationId=${params.locationId}`;
    }

    if (params.clientId) {
      query += `&clientId=${params.clientId}`;
    }

    if (params.searchQuery) {
      query += `&searchQuery=${params.searchQuery}`;
    }

    if (params.selectedCompletionStatus) {
      query += `&requestStatus=${params.selectedCompletionStatus}`;
    }

    if (params.selectedKeyFob) {
      query += `&keyFobId=${params.selectedKeyFob}`;
    }

    if (params.selectedReqAckStatus !== undefined && params.selectedReqAckStatus !== null) {
      query += `&reqAckStatusId=${params.selectedReqAckStatus}`;
    }

    if (params.fromDate) {
      query += `&fromDate=${params.fromDate}`;
    }

    if (params.toDate) {
      query += `&toDate=${params.toDate}`;
    }

    const res = await axios.get(query);

    return res.data as LogParkingHistoryApiResponse;
  } catch (error) {
    throw error;
  }
};
